<template>
	<div class="main-content" v-loading="loading">
		<div class="cat" v-if="!loading">
			<div v-if="!empty">
				<div class="cats-left">
					<div class="cats-title">商品分类</div>
					<div class="cats-list">
						<div class="cats-lable " v-bind:class="{'active': catIndex==index }" v-for="(item, index) in leftCats" @click="bindShowRightcats(index)">{{item.number}}
							{{item.name}}</div>
					</div>
				</div>
				<div class="cats-right">
					<div class="cats-right-header">
						<div class="inline ml20">
							<div>
								<el-select v-model="value" placeholder="请选择">
									<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
									</el-option>
								</el-select>
								<div class='search-input ml20'>
									<el-input v-model="keyword" placeholder="请输入关键字搜索"></el-input>
								</div>

								<button class="search-bnt ml20" @click="bindSearch">查询</button>
							</div>
						</div>
						<div class="step-progress" style="padding-top: 10px;padding-right: 20px;">
							<div class="step-slider step-active">商品分类<span class="iconfont iconchangjiantou-you"></span></div>
							<div class="step-slider">购物车<span class="iconfont iconchangjiantou-you"></span></div>
							<div class="step-slider">确认订单<span class="iconfont iconchangjiantou-you"></span></div>
							<div class="step-slider">审核订单<span class="iconfont iconchangjiantou-you"></span></div>
							<div class="step-slider">总部受理订单</div>
						</div>
					</div>
					<div class="right-main">
						<div class="cats-left">
							<div class="secondary-titlt">{{leftCats[catIndex].number}} {{leftCats[catIndex].name}}</div>
							<div class="cats-list-secondary">
								<div class="cats-lable" style="text-align:left;" v-bind:class="{'active': itemIndex==index }" v-for="(item, index) in leftCats[catIndex].items"
								 @click="bindShowRightCart(index)">{{item.number}} {{item.name}}</div>
							</div>

						</div>
						<div class="cart">
							<div class="cart-navbar">
								<div class="fl">{{leftCats[catIndex].items[itemIndex].number}} {{leftCats[catIndex].items[itemIndex].name}}</div>
								<div class="fr checkout-confirm" @click="addItem()">添加到购物车</div>
							</div>
							<div style="position: relative;">
								<div class="commodity" v-loading="loading_item">
									<div v-if='!loading_item' style="padding-bottom: 40px;">
										<div v-if='items.length>0'>
											<div class="swipeout-content" v-for="(item,index) in items">
												<div class="item-media">
													<img v-if="item.image_path" :src="item.image_path" />
													<img v-else src="../assets/images/default-item.jpg" />
												</div>
												<div class="item-inner">
													<div>助记码：{{item.mnemonic_code}}</div>
													<div>条形码：{{item.barcode}}</div>
													<div>商品名称：{{item.name}}</div>
													<div>起订单位：{{item.sale_unit}}</div>
													<div>规格型号：{{item.sku_name}}</div>
													<div>价格：{{item.price}}</div>
													<div>订货数量：<div class="amount-unit">
															<el-input placeholder="请输入数量" @focus='bindSalePriceFocus(index)' @blur='changeQty(index)' v-model="item.sale_price_unit_qty"></el-input>
														</div>{{item.sale_price_unit}}
														<div class="amount-unit ml20">
															<el-input placeholder="请输入数量" @focus='bindSaleUnitFocus(index)' v-model="item.sale_unit_qty" @blur='changeNuitQty(index)'>
															</el-input>
														</div>{{item.sale_unit}} <span v-if="item.sale_unit_qty%1 != 0" style="color: red;margin-left: 10px;">(请整件下单)</span>
													</div>
												</div>
												<!-- <div class="bnt-add-car" @click="addItem(index)">加入购物车</div> -->
											</div>
										</div>
										<div v-else class="emptyp-data">--暂无数据--</div>
									</div>
								</div>
								<div class="pagination-change" v-if="page_count>1">
									<el-pagination @size-change="bindCatalog" @current-change="bindCatalog" :current-page.sync="page" :page-size="page_size"
									 layout="prev, pager, next, jumper" :total="page_total">
									</el-pagination>
								</div>

							</div>
						</div>
					</div>

				</div>
			</div>
			<div v-if="empty" style="text-align: center;color: #999;">--暂无数据--</div>
		</div>


	</div>

</template>

<script>
	import Vheader from '@/views/header'
	export default {
		data() {
			return {
				options: [{
					value: '2',
					label: '助记码'
				}, {
					value: '1',
					label: '商品名称'
				},{
					value: '3',
					label: '条形码'
				}],
				value: '2',
				input: '',
				leftCats: [],
				catIndex: 0,
				itemIndex: 0,
				loading: true,
				keyword: '',
				items: [],
				page: 1,
				page_size: 10,
				page_count: 1,
				page_total: 0,
				disable: false,
				loading_item: true,
				empty: false,
				sale_price_unit_qty: 0,
				sale_unit_qty: 0
			}
		},

		created: function() {
			this.reload();
			Vheader.methods.getCartItemsCount();
		},
		methods: {
			reload: function() {
				var me = this;
				this.https.fetchGet('/pc/service/catalog/item/cats').then((res) => {
					if (res.data.success) {
						var data = res.data.content;
						if (data.length > 0) {
							me.leftCats = data;
							me.bindCatalog();
						} else {
							this.empty = true;
							this.loading = false;
						}

					}
				}).catch(err => {
					console.log(err)
				})
			},
			//左边一级分类
			bindShowRightcats: function(index) {
				this.catIndex = index;
				this.itemIndex = 0;
				this.bindCatalog();
			},
			//二级分类
			bindShowRightCart: function(index) {
				this.itemIndex = index;
				this.bindCatalog();
			},
			//右边商品
			bindCatalog: function() {
				var me = this;
				me.loading_item = true;
				var cid = me.leftCats[me.catIndex].items[me.itemIndex].id;
				if (me.keyword != '') {
					cid = '';
				}
				this.https.fetchGet('/pc/service/catalog/item/index' + '?cid=' + cid + '&type=' + me.value + '&keyword=' +
						me.keyword + '&page=' + me.page)
					.then((res) => {
						me.loading_item = false;
						if (res.data.success) {
							var data = res.data.content;
							for (var i=0;i<data.items.length;i++) {
								data.items[i].sale_price_unit_qty = 0;
								data.items[i].sale_unit_qty = 0;
							}
							me.items = data.items;
							me.page_count = data.page_count;
							this.page_total = data.page_count * this.page_size;
							me.loading = false;
						}

					}).catch(err => {
						me.loading_item = false;
						console.log(err)
					})
			},
			//搜索商品
			bindSearch: function() {
				this.page = 1;
				this.bindCatalog();
			},
			//添加商品数量
			changeQty: function(index) {
				if(this.items[index].sale_price_unit_qty ==''){
					this.items[index].sale_price_unit_qty =this.sale_price_unit_qty;
				}
				if (this.items[index].sale_price_unit_qty > 0) {
					this.items[index].sale_price_unit_qty = parseInt(this.items[index].sale_price_unit_qty);
					this.items[index].sale_unit_qty = (this.items[index].sale_price_unit_qty / this.items[index].convert_numerator).toFixed(
						2);
				} else {
					this.items[index].sale_price_unit_qty = 0;
					this.items[index].sale_unit_qty = 0;
				}

			},
			//获取焦点
			bindSalePriceFocus: function(index) {
				this.sale_price_unit_qty = this.items[index].sale_price_unit_qty;
				this.items[index].sale_price_unit_qty = '';
			},
			bindSaleUnitFocus: function(index) {
				this.sale_unit_qty = this.items[index].sale_unit_qty;
				this.items[index].sale_unit_qty = '';
			},
			changeNuitQty: function(index) {
				if (this.items[index].sale_unit_qty == '') {
					this.items[index].sale_unit_qty = this.sale_unit_qty
				}
				if (this.items[index].sale_unit_qty > 0) {
					this.items[index].sale_price_unit_qty = parseInt(this.items[index].sale_unit_qty * this.items[index].convert_numerator);
				} else {
					this.items[index].sale_price_unit_qty = 0;
					this.items[index].sale_unit_qty = 0;
				}
			},
			//添加入购物车
			addItem: function() {
				var items = [];
				for (var i=0;i<this.items.length;i++) {
					if (this.items[i].sale_price_unit_qty > 0) {
						var vuale = {
							"k3cloud_number": this.items[i].k3cloud_number,
							"k3cloud_master_id": this.items[i].k3cloud_master_id,
							"sale_price_unit_qty": this.items[i].sale_price_unit_qty,
							"sale_unit_qty": this.items[i].sale_unit_qty
						}
						items.push(vuale);
					}
				}
				var params = {
					items: JSON.stringify(items)
				}
				if (items.length == 0) {
					this.$message({
						type: 'warning',
						message: '请填写订货数量'
					});
					return;
				}
				if (this.disable) return;
				this.disable = true;
				this.https.fetchPost('/pc/service/trade/cart/add-item', params).then((res) => {
					this.disable = false;
					if (res.data.success) {
						this.$message({
							type: 'success',
							message: '添加成功'
						});
						Vheader.methods.getCartItemsCount();
					}
				}).catch(err => {
					console.log(err)
				})
				// if (this.items[index].sale_price_unit_qty > 0) {
				// 	if (this.disable) return;
				// 	this.disable = true;
				// 	var items = [{
				// 		"k3cloud_number": this.items[index].k3cloud_number,
				// 		"k3cloud_master_id": this.items[index].k3cloud_master_id,
				// 		"sale_price_unit_qty": this.items[index].sale_price_unit_qty,
				// 		"sale_unit_qty": this.items[index].sale_unit_qty
				// 	}];
				// 	var params = {
				// 		items: JSON.stringify(items)
				// 	}
				// 	this.https.fetchPost('/pc/service/trade/cart/add-item', params).then((res) => {
				// 		this.disable = false;
				// 		if (res.data.success) {
				// 			this.$message({
				// 				type: 'success',
				// 				message: '添加成功'
				// 			});
				// 		}
				// 	}).catch(err => {
				// 		console.log(err)
				// 	})
				// } else {
				// 	this.$message({
				// 		type: 'warning',
				// 		message: '请填写订货数量'
				// 	});
				// }
			}
		}

	}
</script>

<style>
	.ml20 {
		margin-left: 20px;
	}

	.cat {
		padding: 40px;
		background: #f0f0f0;

	}

	.cats-left {
		width: 250px;
		float: left;
	}

	.cats-right {
		margin-left: 250px;
		min-width: 1150px;
	}

	.cats-title {
		background: rgb(74, 144, 138);
		color: #fff;
		padding: 0 10px;
		height: 60px;
		line-height: 60px;
	}

	.cats-list {
		margin: 0;
		-webkit-padding-start: 0;
		height: 700px;
		background: #fff;
		border-right: 1px solid #DCDFE6;
		overflow-y: auto;
	}

	.step-progress {
		float: right;
	}

	.cats-list-secondary {
		margin: 0;
		-webkit-padding-start: 0;
		background: #fff;

	}

	.secondary-titlt {
		border-bottom: 1px solid #DCDFE6;
		font-weight: bold;
		padding: 10px;
	}

	.cats-lable {
		padding: 10px;
		background: #;
		cursor: pointer;
		display: block;
	}

	.cats-lable:hover {
		background: rgb(225, 234, 233);
	}

	.cats-left .cats-list .cats-lable.active,
	.cats-list-secondary .cats-lable.active {
		background: rgb(225, 234, 233);
	}

	.teer-lable {
		padding: 10px;
		cursor: pointer;
	}

	ul li {
		list-style-type: none;
	}

	.cats-right-header {
		background: #fff;
		border-bottom: 1px solid #DCDFE6;
		padding: 10px 0;
	}

	.search-input {
		display: inline-block;
		width: 200px;
	}

	.search-bnt {
		background: rgb(63, 118, 181);
		border: 0;
		padding: 10px 30px;
		border-radius: 5px;
		color: #fff;
		cursor: pointer;
	}

	.inline {
		display: inline-block;
	}



	.cart {
		margin-left: 250px;
		border-left: 1px solid #DCDFE6;
		width: auto;
		height: 700px;
	}

	.cart-navbar {

		height: 40px;
		border-bottom: 1px solid #DCDFE6;
		line-height: 40px;
		padding-left: 20px;
	}

	.right-main {
		background: #fff;
	}

	.checkout-confirm {
		background: red;
		border-radius: 5px;
		padding: 0 10px;
		height: 30px;
		margin-top: 5px;
		line-height: 30px;
		margin-right: 20px;
		color: #fff;
		cursor: pointer;
	}

	.commodity {
		height: 640px;
		overflow-y: auto;
		position: relative;
		padding: 0 20px;
	}

	.pagination-change {
		position: absolute;
		bottom: 0;
		right: 30px;
		background: #fff;
	}

	.swipeout-content {
		display: flex;
		align-items: center;
		margin-top: 20px;
		position: relative;
		border-bottom: 1px solid #DCDFE6;
		padding-bottom: 10px;
	}

	.item-media {
		width: 200px;
		height: 150px;
		vertical-align: middle;
		margin-right: 20px;
		text-align: center;
	}

	.item-media img {
		vertical-align: middle;
		width: auto;
		height: auto;
		max-width: 100%;
		max-height: 100%;
	}

	.amount-unit {
		display: inline-block;
		width: 100px;
		margin-right: 10px;
	}

	/* 	.item-inner {
		flex: 2;
	} */

	.bnt-add-car {
		background: red;
		padding: 5px 10px;
		border: 0;
		border-radius: 5px;
		color: #fff;
		cursor: pointer;
		margin-right: 20px;
		position: absolute;
		top: 0;
		right: 0;
	}

	.emptyp-data {
		text-align: center;
		margin-top: 50px;
		color: #999;
	}
</style>



// WEBPACK FOOTER //
// src/views/cat.vue